import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    console.log('🔒 Admin Guard: User not authenticated, redirecting to login');
    const returnUrl = state.url;
    router.navigate(['/login'], { 
      queryParams: { returnUrl: returnUrl } 
    });
    return false;
  }

  if (!authService.isAdmin()) {
    console.log('🔒 Admin Guard: User not admin, redirecting to dashboard');
    router.navigate(['/dashboard']);
    return false;
  }

  console.log('🔒 Admin Guard: Admin access granted');
  return true;
};
